<template>
    <router-view v-slot="{ Component }">
        <transition name="page">
            <component :is="Component" />
        </transition>
    </router-view>
</template>

<script>
export default {
    name: 'Calculations'
}
</script>
